import React from 'react';
import RateCheckbox from './rateCheckbox';
import PropTypes from 'prop-types';
import { List, Checkbox, Icon } from 'semantic-ui-react';
import { Trans, useTranslation } from 'react-i18next';

/**
 * Display checkbox of all rates and check box of the group given.
 *
 * @param group: group object to display
 *      {
 *          id: GroupId,
 *          name: "Group Name",
 *          rates:[{ id: RateIdContainingGroup, name:"Rates Name Containing Group"}, {...}]
 *      }
 * @param onGroupChecked: action to perform on check this group
 * @param groupsChecked: Array of groups id checked
 * @param className: classname of group
 * @param ratesChecked: Array of rates id checked
 * @param onRateChecked: action to perform on check on rate in this group
 */
export default function RateGroup({ group, onGroupChecked, groupsChecked, className, ratesChecked, onRateChecked }) {
    let [showCat, setShowCat] = React.useState(true);
    const { t } = useTranslation();

    const renderRates = () => {
        return group.rates.map(rate => <RateCheckbox key={rate.id} className="category-rules-rates" rate={rate} onRateChecked={onRateChecked} ratesChecked={ratesChecked} />);
    };

    const renderGroupRates = () => {
        if (!showCat) {
            return null;
        }

        return renderRates();
    };

    const renderCountGroup = () => {
        let countRatesSelected = group.rates.filter(rate => ratesChecked.includes(rate.id)).length;

        if (group.rates.length === 0) {
            return (
                <span className={'category_label_rate_selected'}>
                    <Trans i18nKey="ticket.resales.config.no_rates_in_category">(aucun tarif dans la catégorie)</Trans>
                </span>
            );
        }

        return (
            <span className={'category_label_rate_selected'}>
                {countRatesSelected} / {group.rates.length}
            </span>
        );
    };

    return (
        <>
            <List.Item className={className}>
                <List.Content className="rate-style">
                    <Icon name={showCat ? 'caret down' : 'caret right'} onClick={() => setShowCat(!showCat)} />
                    <Checkbox
                        label={t('ticket.resales.config.category_row_label') + group.name}
                        checked={groupsChecked.includes(group.id)}
                        onChange={(_, { checked }) => onGroupChecked(group, checked)}
                    />
                    {renderCountGroup()}
                </List.Content>
            </List.Item>
            {renderGroupRates()}
        </>
    );
}

RateGroup.propTypes = {
    className: PropTypes.string.isRequired,
    group: PropTypes.object.isRequired,
    groupsChecked: PropTypes.array.isRequired,
    onGroupChecked: PropTypes.func.isRequired,
    ratesChecked: PropTypes.array.isRequired,
    onRateChecked: PropTypes.func.isRequired
};
